import { render, staticRenderFns } from "./AAsignarCargo.vue?vue&type=template&id=6eec109f&scoped=true"
import script from "./AAsignarCargo.vue?vue&type=script&lang=js"
export * from "./AAsignarCargo.vue?vue&type=script&lang=js"
import style0 from "./AAsignarCargo.vue?vue&type=style&index=0&id=6eec109f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eec109f",
  null
  
)

export default component.exports